module.exports = __webpack_public_path__ + "img/Group 24.278c3d27.svg";